<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    style="width: 300px"
    placeholder="Pilih Uom Produk"
    allow-clear
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
    v-bind="$attrs"
    :loading="loading"
    :show-arrow="true"
  >
    <a-select-option v-for="d in dataRegional" :key="d.id" :label="d.uom">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.uom)"></span>
      <!--eslint-enable-->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, toRefs, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      default: () => null,
      type: String,
    },
    product_id: {
      default: () => '',
      type: [String, Array],
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const dataRegional = ref([])
    const findText = ref(null)
    const product_id = toRefs(props).product_id
    const loading = ref(false)

    const fetchData = (product_id) => {
      if (product_id.length <= 0) {
        product_id = null
      } else {
        product_id = typeof product_id == "object" ? product_id[0] : product_id
      }

      loading.value = true
      apiClient
        .get('/api/filter/uom-by-product', { params: { id: product_id } })
        .then(response => {
          const sorted = response.data
          dataRegional.value = sorted.sort((a, b) =>
            a.uom.toLowerCase() > b.uom.toLowerCase() ? 1 : -1,
          )
        })
        .finally(() => {
          loading.value = false
        })
    }
    onMounted(() => {
      fetchData(product_id.value)
    })
    watch([product_id], (after, before) => {
      emit('update:value', [])
      fetchData(after)
    })

    const onSearch = debounce(value => {
      loading.value = true
      findText.value = value
      fetchData(product_id.value, value)
    }, 300)

    const highlight = value => {
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }
    return {
      dataRegional,
      valueState: useVModel(props, 'value'),
      findText,
      highlight,
      onSearch,
      loading,
    }
  },
}
</script>
